import React, { useEffect, useState, useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import { Panel } from '../../components/Panel';
import UserForm from '../../components/UserForm';
import IconComponent from '../../components/IconComponent';
import TwoFactorSettings from '../../components/TwoFactorSettings';
import PasswordChangeForm from '../../components/PasswordChangeForm';
import { ModelUser } from '@dia-ui/util_interlink-api';

/**
 * which of the three areas is shown. the value is the suffix of the radio id as
 * well, so the ids stay readable in the dom
 */
type PersonalDataTab = 'profile' | 'security' | 'password';

export function PersonalData() {
  const {
    services: {
      serviceAuth
    },
    I18N,
    getRoutes
  } = useContext(AppContext);

  const ROUTE_CONFIG = getRoutes();
  const [user, setUser] = useState<ModelUser>();
  const [activeTab, setActiveTab] = useState<PersonalDataTab>('profile');

  useEffect(() => {
    const fetchUser = () => {
      const userData = serviceAuth.getUser();
      if (userData) {
        setUser(userData);
      }
    };

    fetchUser();
  }, [serviceAuth]);

  /**
   * tab
   *
   * dia-tabs is pure css over a radio group, so the tab strip is a radio group:
   * arrow keys move through it and the change handler fires on every move, which
   * is exactly the behaviour of an automatically activated tab list.
   *
   * the ids and the group name are prefixed with personal-data on purpose. the
   * login card and the partner overview both use id="dia-tab1"/"dia-tab2" and
   * name="tabset"; reusing either would join two unrelated radio groups and let
   * a click here uncheck a tab over there.
   *
   * @param key
   * @param label already translated
   */
  const tab = (key: PersonalDataTab, label: string) => {
    const id = 'personal-data-tab-' + key;

    return (
      <>
        <input
          type="radio"
          name="personal-data-tabset"
          id={ id }
          aria-controls="personal-data-tab-panel"
          checked={ activeTab === key }
          onChange={ () => setActiveTab(key) }
        />
        <label htmlFor={ id }>{ label }</label>
      </>
    );
  };

  return (
        <>
          <Panel
            header={
              <>
                <IconComponent iconName={ ROUTE_CONFIG.PERSONAL_DATA.icon } />
                { ROUTE_CONFIG.PERSONAL_DATA.title }
              </>
            }
          >
            <dia-tabs data-personal-data-tabs>
              { tab('profile', I18N.t("Meine Daten")) }
              { tab('security', I18N.t("Sicherheit")) }
              { tab('password', I18N.t("Passwort")) }
            </dia-tabs>

            { /* one panel that swaps its content instead of three hidden ones:
                 the tabs are controlled here, so a hidden panel would only be
                 dead markup - and the two factor screen must not keep polling
                 while nobody looks at it */ }
            <div id="personal-data-tab-panel" data-personal-data-panel={ activeTab }>
              { activeTab === 'profile' && <UserForm user={ user } /> }
              { activeTab === 'security' && <TwoFactorSettings /> }
              { activeTab === 'password' && <PasswordChangeForm /> }
            </div>
          </Panel>
        </>
  );
}
